import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IMccField {
	fieldId: string;
	changeMccCardMcc: (id: string, value: Nullable<number>) => void;
	setShowAdditionalMccCards: (value: boolean) => void;
}

const MccField: React.FC<IMccField> = ({ fieldId, changeMccCardMcc, setShowAdditionalMccCards }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			({ getFieldValue }) => ({
				validator(_, value) {
					if (getFieldValue(`cardBrand-${fieldId}`) && !value) {
						setShowAdditionalMccCards(true);
						return Promise.reject(new Error(t('enterMcc')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t, fieldId],
	);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeMccCardMcc(fieldId, value);
		},
		[changeMccCardMcc],
	);

	return (
		<FormInput
			testId="MccField"
			type="number"
			min={1000}
			max={9999}
			name={`mcc-${fieldId}`}
			label="mccLabel"
			onChangeNumber={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(MccField);
